import React, { useState } from "react";
import PropTypes from "prop-types";
import { Icon } from "../../Icon";
import { SlideOutMenuPanel } from "../SlideOutMenuPanel/SlideOutMenuPanel";
import { MenuNav } from "./Nav/MenuNav";
// TODO: Migrate Hotel Search Box
// import { HotelSearchBox } from "../../HotelSearchBox/HotelSearchBox";
import { GatewayMenu } from "../GatewayMenu/GatewayMenu";
import { LanguageToggle } from "../../LanguageToggle";
import styles from "./Menu.module.scss";

const Menu = ({
	labels,
	renderMenuLink,
	menuLinks,
	currentLanguage,
	languagePages,
	showGateway,
	onGatewayChange,
	handleChangeLanguage,
	focusOnShouldIgnore,
}) => {
	const [isMenuOpened, setIsMenuOpened] = useState(false);

	const handleOpenMenu = () => {
		setIsMenuOpened(true);
	};

	const handleCloseMenu = () => {
		setIsMenuOpened(false);
	};

	return (
		<nav aria-label={labels.menu}>
			<button
				type="button"
				className={styles.hamburgerMenuButton}
				onClick={handleOpenMenu}
				aria-label={labels.openMenu}
				aria-expanded={isMenuOpened}
				aria-controls="main-menu-nav">
				<Icon name="menu" className={styles.hamburgerMenuButtonIcon} />
			</button>
			<SlideOutMenuPanel
				id="main-menu-nav"
				labels={{
					title: labels.menu,
					closeMenu: labels.closeMenu,
				}}
				isOpen={isMenuOpened}
				handleClose={handleCloseMenu}>
				{/* TODO: Migrate Hotel Search Box */}
				{/* <HotelSearchBox currentLanguage={currentLanguage?.substring(0, 2)} /> */}
				<MenuNav
					isOpen={isMenuOpened}
					renderMenuLink={renderMenuLink}
					menuLinks={menuLinks}
					unmountTrap={handleCloseMenu}
				/>
				<GatewayMenu
					labels={labels}
					showGateway={showGateway}
					onGatewayChange={onGatewayChange}
					focusOnShouldIgnore={focusOnShouldIgnore}
				/>
				<LanguageToggle
					classNames={{
						container: styles.languageSwitcher,
						currentLanguage: styles.languageSwitcherCurrentLanguage,
						altLanguage: styles.languageSwitcherAltLanguage,
					}}
					currentLanguage={currentLanguage}
					languagePages={languagePages}
					handleChangeLanguage={handleChangeLanguage}
				/>
			</SlideOutMenuPanel>
		</nav>
	);
};

Menu.propTypes = {
	labels: PropTypes.shape({
		menu: PropTypes.string,
		openMenu: PropTypes.string,
		closeMenu: PropTypes.string,
		openGatewayMenu: PropTypes.string,
		closeGatewayMenu: PropTypes.string,
		changeGateway: PropTypes.string,
		gatewayHeader: PropTypes.string,
	}),
	renderMenuLink: PropTypes.func,
	menuLinks: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			links: PropTypes.arrayOf(
				PropTypes.shape({
					displayTitle: PropTypes.string,
					links: PropTypes.arrayOf(
						PropTypes.shape({
							id: PropTypes.string,
							linkText: PropTypes.string,
							url: PropTypes.string,
							target: PropTypes.string,
						})
					),
					id: PropTypes.string,
					linkText: PropTypes.string,
					url: PropTypes.string,
					target: PropTypes.string,
				})
			),
		})
	),
	currentLanguage: PropTypes.string,
	languagePages: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			lang: PropTypes.string.isRequired,
			path: PropTypes.string.isRequired,
		}).isRequired
	).isRequired,
	showGateway: PropTypes.bool,
	onGatewayChange: PropTypes.func,
	handleChangeLanguage: PropTypes.func,
	focusOnShouldIgnore: PropTypes.func,
};

Menu.defaultProps = {
	labels: {
		menu: "Menu",
		openMenu: "Open menu",
		closeMenu: "Close menu",
		openGatewayMenu: "Open gateway menu",
		closeGatewayMenu: "Close gateway menu",
		changeGateway: "Change gateway",
		gatewayHeader: "Gateway",
	},
	renderMenuLink: (link, { classNames }) => (
		<a href={link.url} target={link.target} className={classNames?.link}>
			{link.linkText}
		</a>
	),
	menuLinks: [],
	currentLanguage: null,
	showGateway: true,
	onGatewayChange: () => {},
	handleChangeLanguage: () => {},
	focusOnShouldIgnore: () => true,
};

export default Menu;
export { Menu };
